import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import audit from './slices/auditSlice'

// Create persist configuration
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['theme', 'auth'], // Only these slices will be persisted
}

// Combine your reducers
const rootReducer = (asyncReducers) => combineReducers({
    theme,
    auth,
    audit,
    ...asyncReducers,
})

// Wrap your rootReducer with persistReducer
const persistedReducer = (asyncReducers) => persistReducer(persistConfig, rootReducer(asyncReducers))

export default persistedReducer
